import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import dayjs from 'dayjs';

import useAttendanceEvent from '../../hooks/useAttendanceEvent';

interface Props {
    eventId: string;
}

function StampPanel({ eventId }:Props) {
    const { progress, policy } = useAttendanceEvent(eventId);
    if (policy) {
        const { milestones } = policy;
        const {
            beforeStampImageUrl, afterStampImageUrl, milestoneStampImageUrl,
            backgroundImageUrl,
        } = policy;
        const goalCounts = milestones.map((it) => it.goalCount);
        const maxCount = milestones
            .reduce((acc, cur) => Math.max(acc, cur.goalCount), 0);
        const currentCount = progress?.currentCount || 0;

        return (
            <Container>
                <BackgroundImage src={backgroundImageUrl} />
                {Array.from({ length: maxCount }).map((_, idx) => {
                    const isAfter = currentCount > idx;
                    const isGoalLab = goalCounts.includes(idx + 1);
                    let imageUrl = beforeStampImageUrl;
                    if (isGoalLab) {
                        imageUrl = milestoneStampImageUrl;
                    } else if (isAfter) {
                        imageUrl = afterStampImageUrl;
                    }
                    const date = progress?.attendanceDates?.[idx];
                    console.log({ date });
                    return (
                        <Column align='center' spacing={0.5} css={css`position: relative`}>
                            <StampImage src={imageUrl}
                                key={`stamp ${idx}`}
                                width='100%'
                                isGray={isGoalLab && (!isAfter)} />
                            {date && (
                                <Text color={colors.primary} size='label-lg' fontWeight='medium'>
                                    {dayjs(date).format('MM.DD')}
                                </Text>
                            )}
                        </Column>
                    );
                })}
            </Container>
        );
    }

    return null;
}

const Container = styled.div`
    width: 100%;
    padding: 12px 16px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 8px;
    position: relative;
`;

const StampImage = styled(Image, {
    shouldForwardProp: (prop) => prop !== 'isGray',
})<{
    isGray?: boolean;
}>`
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;
    position: relative;
    filter: ${({ isGray }) => (isGray ? 'grayscale(0.5)' : 'none')};
`;

const BackgroundImage = styled(Image)`
    position: absolute;;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export default StampPanel;
